<template>
    <div class="popup" v-if="isShowStarFeedbackPopup">
        <div class="content" id="userStarFeedback" :data-language="$i18n.locale">
            <div id="starFeedbackClose">
                <div class="icon-star-close" @click="closeStarFeedbackPopup()"></div>
            </div>
            <div id="starFeedbackTitle">{{$t('language.popup.userStarPopup.feedbackTitle')}}</div>
            <div id="starFeedbackContentBox">
                <textarea id="starFeedbackContent" :placeholder="$t('language.popup.userStarPopup.feedbackDesc')" spellcheck="false" maxlength="1000" v-model.trim="feedbackContent"></textarea>
            </div>
            <button id="starFeedbackBtn" @click="okStarFeedbackPopup()">{{$t('language.popup.userStarPopup.feedbackBtn')}}</button>
            <div id="contentCount">
                <div><span>{{ feedbackContent.length }}</span>/1000</div>
            </div>
        </div>
    </div>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    data() {
        return {
            // 是否显示弹窗
            isShowStarFeedbackPopup: false,
            // 反馈内容
            feedbackContent: ""
        }
    },
    methods: {
        // 关闭
        closeStarFeedbackPopup() {
            this.isShowStarFeedbackPopup = false;
        },
        // 确定
        okStarFeedbackPopup() {
            if (this.feedbackContent == "") {
                this.$toast({
                    text: this.$t('language.popup.userStarPopup.feedbackNo'),
                    type: 'fail',
                    idValue: "rightContBan"
                });
            } else {
                this.isShowStarFeedbackPopup = false;
                this.$toast({
                    text: this.$t('language.popup.userStarPopup.feedbackYes'),
                    type: 'success',
                    idValue: "rightContBan"
                });
                taskListUtils.userStarUpdateRequest({createReason:1,content:this.feedbackContent});
            }
        }
    }
}
</script>

<style>
#userStarFeedback {
     width: 400px;
     height: 375px;
     border-radius: 16px;
     text-align: center;
     border: 1px solid #FFF;
     font-family: "Segoe UI", "Arial", "Microsoft YaHei", "微软雅黑";
}
/* 关闭 */
#starFeedbackClose {
    position: absolute;
    z-index: 1;
    right: 8px;
    top: 8px;
}
#starFeedbackClose>.icon-star-close {
    width: 40px;
    height: 40px;
    display: inline-block;
    background-image: url("../../../assets/images/userStar/icon-close.svg");
    background-position: 0px 0px;
    cursor: pointer;
}
#starFeedbackClose>.icon-star-close:hover {
    background-image: url("../../../assets/images/userStar/icon-close-hover.svg");
}
#starFeedbackClose>.icon-star-close:active {
    opacity: 0.8;
}
/* 标题 */
#starFeedbackTitle {
    font-size: 20px;
    font-weight: bolder;
    line-height: 26px;
    margin: 40px 24px 0px 24px;
}
/* 反馈内容外框 */
#starFeedbackContentBox {
    width: 352px;
    height: 202px;
    margin: 15px 24px;
    padding: 16px 0;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.08);
}
/* 反馈内容 */
#starFeedbackContent {
    width: 348px;
    height: 160px;
    border-radius: 4px;
    margin-right: 3px;
    line-height: 20px;
    font-family: "Segoe UI", "Arial", "Microsoft YaHei", "微软雅黑";
    box-sizing: border-box;
    padding: 0 16px;
    resize: none;
    outline: none;
    border: none;
    scrollbar-width: thin;
    cursor: default;
}
/* 法语特殊处理 */
#userStarFeedback[data-language=france] #starFeedbackContentBox {
    height: 182px;
}
#userStarFeedback[data-language=france] #starFeedbackContent {
    height: 140px;
}
/* 滚动条 */
#starFeedbackContent::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
}
#starFeedbackContent::-webkit-scrollbar-thumb {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.08);
}
/* 提示文字颜色 */
#starFeedbackContent::placeholder {
    color: #999999;
}
/* 反馈按钮 */
#starFeedbackBtn {
    font-family: "Segoe UI", "Arial", "Microsoft YaHei", "微软雅黑";
    padding: 8px 54px !important;
    border-radius: 4px;
    font-size: 16px;
    height: 36px;
}
/* 计数 */
#contentCount {
    font-size: 12px;
    color: #CCCCCC;
    position: relative;
    margin: 0px 24px;
}
#contentCount>div {
    text-align: right;
    position: absolute;
    right: 10px;
    top: -72px;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/user_star_feedback_popup.vue